import {DiscordRoleData} from "../../data/discord/DiscordRoleData";
import {Alert, Checkbox, Stack, Typography} from "@mui/material";
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SecurityIcon from '@mui/icons-material/Security';
import CheckIcon from '@mui/icons-material/Check';
import React, {useState} from "react";
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';

interface DiscordRoleProps {
    role: DiscordRoleData,
    checked: boolean,
    doClick: (role: DiscordRoleData) => void
}

export const DiscordRole = (props: DiscordRoleProps) => {
    const [checked, setChecked] = useState(props.checked)

    let icon
    if (props.role.blocked) {
        icon = <SmartToyIcon sx={{color: props.role.color}} />
    } else if (props.role.untouchable) {
        icon = <DoNotDisturbIcon sx={{color: props.role.color}} />
    } else {
        if (props.role.discordAdmin) {
            icon = <SecurityIcon sx={{color: props.role.color}} />
        } else {
            icon = <CheckIcon sx={{color: props.role.color}} />
        }
    }

    return <Alert variant="outlined" color={"info"} sx={{
        color: props.role.color,
        borderColor: props.role.color
    }} icon={<></>}>
        <Stack direction={"row"} spacing={2} alignItems={"center"}>
            {icon}
            <Typography>{props.role.displayName}</Typography>
            {!props.role.blocked && !props.role.untouchable ?
                <Checkbox sx={{color: props.role.color, '&.Mui-checked': {color: props.role.color}}}
                    checked={checked}
                    onChange={() => {
                        props.doClick(props.role)
                        setChecked(!checked)
                    }}
                /> : <></>}
        </Stack>
    </Alert>
}